// currencyFormatterUSD needed to denote international (ie non-locale-specific) amounts.
// for instance: movie.budget or movie.revenue
/** @deprecated use useFormat hook */
export const currencyFormatterUSD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});

export function getCurrencySymbolFromCode(currencyCode: string) {
    switch (currencyCode) {
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'USD':
            return '$';
        default:
            return '€';
    }
}

// TODO: Use sth like this
// export type Locale =
//     'de-DE' |
//     'en-US'
//
// export type Currency =
//     'EUR' |
//     'USD'

// for all other locale-specific currency formatting:
/** @deprecated use useFormat hook */
export function currencyFormatterFunction(value: number, locale: string, currency: string): string {
    if (currency) {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
        }).format(value);
    }
    return null;
}
